export const parsePercentage = (total: number, partition: number): string =>
	Intl.NumberFormat("nl-BE", { style: "percent", minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(partition / total);
